
<div class="val-simple-panel">
  <div class="val-simple-panel-contenu"
       [ngClass]="{'val-invisible': cacherContenu}">
    <ng-content></ng-content>
  </div>
</div>
